import { render } from "./SldDiy.vue?vue&type=template&id=a9cfd594&scoped=true"
import script from "./SldDiy.vue?vue&type=script&lang=js"
export * from "./SldDiy.vue?vue&type=script&lang=js"

import "./SldDiy.vue?vue&type=style&index=0&id=a9cfd594&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a9cfd594"

export default script